import React from 'react';
import useNavigation from 'enhancers/use-navigation';

import CreateAccountSkeleton from './steps/create-account/create-account.skeleton';
import { initialRegistrationStep } from './registration.settings';
import { getModuleIdFromStepRouteParam } from './utils';

const Registration: React.FunctionComponent = () => {
  const [navigation] = useNavigation();

  React.useLayoutEffect(() => {
    const moduleId = getModuleIdFromStepRouteParam(initialRegistrationStep);

    if (!moduleId) return;

    navigation[moduleId]();
  }, [navigation]);

  return <CreateAccountSkeleton />;
};

export default React.memo(Registration);
